import { defineStore } from 'pinia';

export interface Note {
  noteId: number;
  text: string;
  createdAt: string;
}

interface NotesState {
  notesByKey: Record<string, Record<string | number, Note[]>>;
}

export const useNotesStore = defineStore('notesStore', {
  state: (): NotesState => ({
    notesByKey: {},
  }),
  persist: true,
  actions: {
    getNotes(dataKey: string, id: string | number): Note[] {
      return this.notesByKey[dataKey]?.[id] || [];
    },
    addNote(dataKey: string, id: string | number, text: string) {
      const note: Note = {
        noteId: Date.now(),
        text,
        createdAt: new Date().toISOString(),
      };
      if (!this.notesByKey[dataKey]) this.notesByKey[dataKey] = {};
      if (!this.notesByKey[dataKey][id]) this.notesByKey[dataKey][id] = [];
      this.notesByKey[dataKey][id].push(note);
    },
    updateNote(dataKey: string, id: string | number, noteId: number, text: string) {
      const note = this.getNotes(dataKey, id).find((n) => n.noteId === noteId);
      if (note) note.text = text;
    },
    deleteNote(dataKey: string, id: string | number, noteId: number) {
      if (this.notesByKey[dataKey]?.[id]) {
        this.notesByKey[dataKey][id] = this.notesByKey[dataKey][id].filter(
          (n) => n.noteId !== noteId,
        );
      }
    },
  },
});
